import { APP_BASE_HREF } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ApplicationConfig, isDevMode } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { provideServiceWorker } from "@angular/service-worker";

import { withNgxsReduxDevtoolsPlugin } from "@ngxs/devtools-plugin";
import { withNgxsRouterPlugin } from "@ngxs/router-plugin";
import { provideStore } from "@ngxs/store";

import { ConfirmationService, MessageService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";

import { withNgxsResetPlugin } from "ngxs-reset-plugin";

import { ErrorInterceptor } from "@core/services/interceptors/error.interceptor";
import { ScreenWidthDetectorService } from "@core/services/screen-width-detector.service";
import { CoreState } from "@core/store/core.state";

import { environment } from "../environments/environment";
import { routes } from "./app.routes";
import { AuthPageState } from "./auth-page/store/auth.state";

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        provideServiceWorker("assets/ng/ngsw-worker.js", {
            enabled: !isDevMode(),
            registrationStrategy: "registerImmediately",
        }),

        provideStore(
            [CoreState, AuthPageState],
            { developmentMode: !environment.production },
            withNgxsReduxDevtoolsPlugin(),
            withNgxsRouterPlugin(),
            withNgxsResetPlugin()
        ),

        {
            provide: APP_BASE_HREF,
            useValue: "/",
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },

        ConfirmationService,
        MessageService,
        DialogService,

        ScreenWidthDetectorService,
    ],
};
